import { Mapper } from '@sdk/sdk';
import { McpClientRequest } from '../auth';
import { ApiMcpClientRequestMap } from './api-mcp-client-request.map';

export class ApiMcpClientRequestMapper implements Mapper<McpClientRequest, ApiMcpClientRequestMap> {
  fromMap(map: ApiMcpClientRequestMap): McpClientRequest {
    const instance = new URL(map.instance);
    return new McpClientRequest({
      clientName: map.client_name,
      isClientVerified: map.client_verified,
      clientHost: map.client_host,
      destinationKind: map.destination.kind,
      destinationHost: map.destination.host,
      instanceHost: instance.host
    });
  }
}
